import { request, getLocale } from '@pb/utils'

import { MembershipDetail } from './duck/types'

const memberDataUrl = `/api/membershipinfo/v1/${getLocale('lowerCase')}.json`

const fetchMemberInfo = async (): Promise<MembershipDetail> => {
  const { data } = await request.get(memberDataUrl, {
    use: {
      apiVersion: false,
      locale: false,
    },
  })
  return data
}

export default {
  fetchMemberInfo,
}
